/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PlayerOrderEnum } from './PlayerOrderEnum';
import {
    PlayerOrderEnumFromJSON,
    PlayerOrderEnumFromJSONTyped,
    PlayerOrderEnumToJSON,
} from './PlayerOrderEnum';

/**
 * 
 * @export
 * @interface ScrimmageRequestRequest
 */
export interface ScrimmageRequestRequest {
    /**
     * 
     * @type {boolean}
     * @memberof ScrimmageRequestRequest
     */
    is_ranked: boolean;
    /**
     * 
     * @type {number}
     * @memberof ScrimmageRequestRequest
     */
    requested_to: number;
    /**
     * 
     * @type {PlayerOrderEnum}
     * @memberof ScrimmageRequestRequest
     */
    player_order: PlayerOrderEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof ScrimmageRequestRequest
     */
    map_names: Array<string>;
}

/**
 * Check if a given object implements the ScrimmageRequestRequest interface.
 */
export function instanceOfScrimmageRequestRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "is_ranked" in value;
    isInstance = isInstance && "requested_to" in value;
    isInstance = isInstance && "player_order" in value;
    isInstance = isInstance && "map_names" in value;

    return isInstance;
}

export function ScrimmageRequestRequestFromJSON(json: any): ScrimmageRequestRequest {
    return ScrimmageRequestRequestFromJSONTyped(json, false);
}

export function ScrimmageRequestRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ScrimmageRequestRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'is_ranked': json['is_ranked'],
        'requested_to': json['requested_to'],
        'player_order': PlayerOrderEnumFromJSON(json['player_order']),
        'map_names': json['map_names'],
    };
}

export function ScrimmageRequestRequestToJSON(value?: ScrimmageRequestRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'is_ranked': value.is_ranked,
        'requested_to': value.requested_to,
        'player_order': PlayerOrderEnumToJSON(value.player_order),
        'map_names': value.map_names,
    };
}

